import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";


export const graphText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical representation of Identified Vulnerabilities to Severity Risk rating",
            size: 22,
            font: "Cambria (Headings)",
            color: 'c00000',
            bold: true,
            italics: false
        }),
    ],
})


export function severityLevelTable(critical, high, medium, low, info) {
    return new Table({
        width: { size: 60, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 1200 },
        borders: {
            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
        },

        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 13, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        indent: { left: 800 },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        width: { size: 59, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Severity Level",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Frequency",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 80 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "Critical",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(critical),
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "2",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 80 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "High",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(high),
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "3",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 80 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "Medium",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(medium),
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "4",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 80 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "Low",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(low),
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "5",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 80 },
                                alignment: AlignmentType.LEFT,
                                children: [
                                    new TextRun({
                                        text: "Informational",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },

                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: String(info),
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),
        ]
    })
}

export const tableText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Table: Representing Severity Level",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: true,
            bold: true
        }),
    ],
})


export const piechartText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical Representation of Identified Gaps",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: true,
            bold: true
        }),
    ],
})